/* eslint-disable */
import { Box, Button, Card, Chip, styled, Typography, useTheme } from "@mui/material";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import { subscriptionHistory } from "../../gql/queries/subcriptions";
import { useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PlanDetails from "./modal/PlanDetails";
import { usePopup } from "../../context/commonPop";
import {formatTimestampToDateNew } from "../../utils/myUtills";
import MainLoader from "../MainLoader/MainLoader";

const BoxWrapper = styled(Box)(({ theme }) => ({
  maxHeight: "calc(100vh - 315px)",
  overflow: "auto",
  "@media screen and (max-width:600px)": {
    maxHeight: "none",
  },
  "&::-webkit-scrollbar-track": {
    WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.3)",
    borderRadius: "10px",
    backgroundColor: "#F5F5F5",
  },
  "&::-webkit-scrollbar": { width: "5px", backgroundColor: "transparent" },
  "&::-webkit-scrollbar-thumb": {
    borderRadius: "10px",
    WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,.3)",
    backgroundColor: theme.palette.primary.main,
  },
  "& .HistoryBoxWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "15px",
    padding: "14px",
    borderBottom: `1px solid ${theme.palette.divider}`,
    "&:last-of-type": { borderBottom: "none" },
    "@media screen and (max-width:600px)": {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "24px",
    },
    "& .PlanStatus": {
      "& .MainHeading": {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        fontSize: "16px",
        fontWeight: 700,
        lineHeight: 1,
        color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
        marginBottom: "8px",
        "& > span": {
          fontSize: "16px",
          fontWeight: 700,
          lineHeight: 1,
          color: theme.palette.primary.main,
        },
        "& .MuiChip-root": {
          marginLeft: "15px",
          border: "1px solid #00CF00",
          backgroundColor: "#00cf001f",
          height: "28px",
          "& .MuiChip-label": {
            lineHeight: "0.8",
            color: "#00CF00",
          },
        },
      },
      "& .Label": {
        fontSize: "14px",
        color: theme.palette.mode === "dark" ? "#ffffff" : "#757575",
        fontWeight: 500,
        lineHeight: 1,
        marginBottom: "12px",
      },
      "& .StartEndDateWrapper": {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "15px",
        "& p": {
          fontSize: "14px",
          color: theme.palette.mode === "dark" ? "#ffffff" : "#757575",
          fontWeight: 500,
          lineHeight: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "6px",
          "& span": {
            fontSize: "14px",
            color: "#2A3547",
            fontWeight: 500,
            lineHeight: 1,
            backgroundColor: "#E3E3E3",
            padding: "4px 12px 4px",
            borderRadius: "100px",
            "@media screen and (max-width:600px)": {
              fontSize: "10px",
            },
          },
        },
      },
    },
    "& .PaymentMethod": {
      "& .Label": {
        fontSize: "14px",
        color: theme.palette.mode === "dark" ? "#ffffff" : "#757575",
        fontWeight: 500,
        lineHeight: 1,
        marginBottom: "8px",
        textAlign: "center",
        "@media screen and (max-width:600px)": {
          textAlign: "left",
        },
      },
      "& .PaymentCardDetails": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        "@media screen and (max-width:600px)": {
          justifyContent: "flex-start",
        },
        "& .CardIconWrapper": {
          backgroundColor: "#F2F6FA",
          padding: "8px 8px 8px",
          borderRadius: "6px",
          "& svg": {
            color: "#2A3547",
            fontSize: "24px",
          },
        },
        "& .CardDetails": {
          "& .CardTitle": {
            fontSize: "14px",
            color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
            fontWeight: 700,
            lineHeight: 1,
            marginBottom: "6px",
          },
          "& .Value": {
            fontSize: "14px",
            color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
            fontWeight: 700,
            lineHeight: 1,
          },
        },
      },
    },
    "& .PaymentDate": {
      "& .Label": {
        fontSize: "14px",
        color: theme.palette.mode === "dark" ? "#ffffff" : "#757575",
        fontWeight: 500,
        lineHeight: 1,
        marginBottom: "8px",
        textAlign: "center",
        "@media screen and (max-width:600px)": {
          textAlign: "left",
        },
      },
      "& .PaymentDate": {
        fontSize: "14px",
        color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
        fontWeight: 700,
        lineHeight: 1,
      },
    },
    "& .PayAmount": {
      "& .Label": {
        fontSize: "14px",
        color: theme.palette.mode === "dark" ? "#ffffff" : "#757575",
        fontWeight: 500,
        lineHeight: 1,
        marginBottom: "8px",
        textAlign: "center",
        "@media screen and (max-width:600px)": { textAlign: "left" },
      },
      "& .PaymentAmount": {
        fontSize: "18px",
        color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
        fontWeight: 700,
        lineHeight: 1,
      },
    },
    "& .BtnWrapper": {
      "& button": {
        textTransform: "none",
        backgroundColor: theme.palette.primary.main,
        color: "#ffffff",
        borderRadius: "5px",
        boxShadow: "none",
        padding: "6px 22px",
        "&:hover": {
          backgroundColor: theme.palette.primary.dark,
          color: "#ffffff",
        },
        "&:focus": {
          outline: "none",
        },
      },
    },
  },
  "& .haveNotPlan": {
    height: "200px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& p": {
      fontSize: "15px",
      color: theme.palette.text.primary,
      fontWeight: 600,
    },
  },
}));

function SubscriptionHistoryTab() {
  const [userHistory, setUserHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const { handleOpen } = usePopup();
  const [projectName, setProjectName] = useState("");
  const [openPlan, setPlanOpen] = useState(false);
  const handlePlanOpen = key => {
    setProjectName(key);
    setPlanOpen(true);
  };
  const handlePlanClose = () => setPlanOpen(false);
  const [getUserPaymentHistory] = useLazyQuery(subscriptionHistory, {
    fetchPolicy: "network-only",
  });
  const { userData } = useSelector(state => state.reducer);
  const isSubscriptionActive = userData?.subscriptionCredits?.subscriptionType || "";

  const fetchPlan = () => {
    setLoading(true);
    getUserPaymentHistory({
      onCompleted: data => {
        if (data && data.getTokenPaymentHistory) {
          const { getTokenPaymentHistory } = data;
          const sorted = [...getTokenPaymentHistory].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

          setUserHistory(sorted);
        }
        setLoading(false);
      },
      onError: err => {
        console.error("Error fetching plan:", err);
        setLoading(false);
        handleOpen(true, "Error fetching plan");
      },
    });
  };

  useEffect(() => {
    fetchPlan();
  }, []);
  const theme = useTheme();
  return (
    <>
      {loading ? (
        <MainLoader />
      ) : (
        <BoxWrapper>
          {userHistory.length === 0 ? (
            <Box className="haveNotPlan">
              <Typography component="p">You haven't subscribed to any plans yet.</Typography>
            </Box>
          ) : (
            userHistory.map((history, index) => (
              <Box className="HistoryBoxWrapper" key={index}>
                <Box className="PlanStatus">
                  <Typography component="h3" className="MainHeading">
                    {index === 0 ? "Current Plan" : "Previous Plan"} : &nbsp;
                    <Typography component="span">{history?.planInfo?.planName}</Typography>
                    {index === 0 && isSubscriptionActive === history?.planInfo?.planName && <Chip label="Active" variant="outlined" />}
                  </Typography>
                  <Typography component="p" className="Label">
                    {history?.planInfo?.planType}
                  </Typography>
                  <Box className="StartEndDateWrapper">
                    <Typography component="p">
                      Start <Typography component="span">{formatTimestampToDateNew(history?.card?.created_at)}</Typography>
                    </Typography>
                    <Typography component="p">
                      End <Typography component="span">{formatTimestampToDateNew(history?.card?.endTime)}</Typography>
                    </Typography>
                  </Box>
                </Box>

                <Box className="PaymentMethod">
                  <Typography component="p" className="Label">
                    Payment Method
                  </Typography>
                  {history.method === "upi" ? (
                    <Typography component="p" className="Value">
                      UPI :- {history?.upi?.vpa}
                    </Typography>
                  ) : (
                    <Box className="PaymentCardDetails">
                      <Typography component="span" className="CardIconWrapper">
                        <CreditCardOutlinedIcon />
                      </Typography>
                      <Box className="CardDetails">
                        <Typography component="p" className="CardTitle">
                          {history?.card?.network}
                        </Typography>
                        <Typography component="p" className="Value">
                          *****{history?.card?.last4}
                        </Typography>
                      </Box>
                    </Box>
                  )}
                </Box>

                <Box className="PaymentDate">
                  <Typography component="p" className="Label">
                    Payment Date
                  </Typography>
                  <Typography component="h5" className="PaymentDate">
                    {formatTimestampToDateNew(history?.card?.created_at)}
                  </Typography>
                </Box>

                <Box className="PayAmount">
                  <Typography component="p" className="Label">
                    Pay Amount
                  </Typography>
                  <Typography component="h4" className="PaymentAmount">
                    {history?.planInfo?.amount}
                  </Typography>
                </Box>

                <Box className="BtnWrapper">
                  <Button
                    className="OutlineBtn"
                    onClick={e => {
                      handlePlanOpen(history?.planInfo?.planName);
                      e.target.blur();
                    }}
                  >
                    View Details
                  </Button>
                </Box>
              </Box>
            ))
          )}
          <PlanDetails handleClose={handlePlanClose} open={openPlan} viewDetails={projectName || ""} />
        </BoxWrapper>
      )}
    </>
  );
}

export default SubscriptionHistoryTab;
